import { render, staticRenderFns } from "./store.vue?vue&type=template&id=dcc96c56&scoped=true&"
import script from "./store.vue?vue&type=script&lang=js&"
export * from "./store.vue?vue&type=script&lang=js&"
import style0 from "./store.vue?vue&type=style&index=0&id=dcc96c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc96c56",
  null
  
)

export default component.exports